import React from "react";
import "../style/card_events.css";
// import mtccImg from "../parm_assets/image_slider_homepage/parm1.png";
// import acpImg from "../parm_assets/image_slider_homepage/parm2.jpeg";
const traqImg = "https://ik.imagekit.io/axiomhives/parm_assets/image_slider_homepage/parm3.jpeg?updatedAt=1769929447782";
const slide1 = "https://ik.imagekit.io/axiomhives/parm_assets/intac_kl/INTAC_BANNER_NEW.png?updatedAt=1769929468176";
const slide2 = "https://ik.imagekit.io/axiomhives/parm_assets/aptcc/acp_banner.jpeg?updatedAt=1769929469314";
const penaungDiraja = "https://ik.imagekit.io/axiomhives/parm_assets/event/Image_lex6jglex6jglex6.png?updatedAt=1781022512805";

const events = [
  {
    id: 1,
    title: "Penaung Diraja PArM",
    description:
      "Persatuan Arborist Malaysia (PArM) dengan penuh hormat dan sukacita mengumumkan pelantikan Yang Mulia Datin Paduka Seri Afzaa Fadini binti Dato’ Abdul Aziz sebagai Penaung Diraja baharu, berkuat kuasa mulai 20 April 2026",
    image: penaungDiraja,
    link: "/article-penaung-diraja-parm",
  },
  {
    id: 2,
    title: "INTAC 2026",
    description:
      "The Malaysian Society of Arborist or better known by its local acronym PArM (Persatuan Arborist Malaysia) is organizing an International Tropical Arboriculture Conference (INTAC 2026) in September, 2026",
    image: slide1,
    link: "/intac2026-parm",
  },
  {
    id: 3,
    title: "ACP 24th",
    description:
      "The Arborist Certification Programme in Malaysia (ACP24) is a certification program offered by the Malaysian Society of Arborist (PArM).",
    image: slide2,
    link: "/eventDetailPage",
  },
  // {
  //   id: 4,
  //   title: "TRAQ 2024",
  //   description:
  //     "TRAQ stands for Tree Risk Assessment Qualified program, a certification for arborists to ensure they can assess and mitigate tree risks effectively.",
  //   image: traqImg,
  //   link: "#",
  // },
];

const EventCard = () => {
  return (
    <section className="event-section">
      <h2 className="section-title">UPCOMING EVENT</h2>
      <div className="event-container">
        {events.map((event) => (
          <div key={event.id} className="event-card">
            <div className="image-wrapper">
              <img src={event.image} alt={event.title} className="event-image" />
            </div>

            {/* 👇 Arrow button aligned to the right */}
            <div className="arrow-wrapper">
              <a href={event.link} className="arrow-btn">
                ➜
              </a>
            </div>

            <div className="event-info">
              <h3>{event.title}</h3>
              <p>{event.description}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default EventCard;